import { useRef, useEffect } from 'react';

export function useAppear(cls = 'appear', threshold = 0.12) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.classList.add(cls);
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { el.classList.add('show'); obs.unobserve(el); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [cls, threshold]);
  return ref;
}
